import React from "react";
import ReactTooltip from "react-tooltip";

export default function Tooltip({title = "",text = ""}) {
  
  return (
    <div>
       <a data-tip data-for="info" src="">
                  <img data-for="info" width="15px" src={require(`../../svg/reclamo/IconoInfo.png`).default} alt="imagen" />
                </a>
           < ReactTooltip className="tooltip" id="info" place="top" type="light" effect='solid' data-for='global'>
       <div className="">
         <div className="tooltip-header">
         <img width="15px" height="15px" className="tooltip-header-elemnts" src={require(`../../svg/reclamo/IconoInfo.png`).default} alt="imagen" />
         <p className="tooltip-header-elemnts">{title}</p>
         </div>
         <hr />
         <div className ="tooltip-body">
       
                {text}
         </div>
       
                
       </div>
      </ReactTooltip>
    </div>
    
  );
}

